import React, {Component}  from "react";
import PropTypes from 'prop-types';
import {arrayMove} from "react-sortable-hoc";
import SortableChapterList from './SortableChapterList';

class SortableChapterContainer extends Component {

    state = {
        chapters: [...this.props.chapters],
        selectedEditChapterPartId: ''
    };

    //Actions
    onSortEnd = ({ oldIndex, newIndex }) => {
        this.setState({
            chapters: arrayMove(this.state.chapters, oldIndex, newIndex)
        }, e => {
            let chapters = this.state.chapters.map((c, i) => {
                return {id: c.id, number: i};
            })
            this.props.reorderChapters(chapters, this.props.user.id)
        });
    };

    setSelectedEditChapterPartId = (id) => {
        if (id !== this.state.selectedEditChapterPartId) {
            this.setState({
                selectedEditChapterPartId: id
            });
        } else {
            this.setState({
                selectedEditChapterPartId: ''
            });
        }
    };

    //Lifecycle
    componentWillReceiveProps(nextProps) {

        if (this.props.chapters !== nextProps.chapters) {
            this.setState({chapters: nextProps.chapters});
        }

    };




    render() {
        return (
            <SortableChapterList
                chapters={this.state.chapters}
                onSortEnd={this.onSortEnd}
                showModalDelete={this.props.showModalDelete}
                setSelectedEditChapterPartId={this.setSelectedEditChapterPartId}
                selectedEditChapterPartId={this.state.selectedEditChapterPartId}
                redirect={this.props.redirect}
                deleteChapterConfirmation={(item) => this.props.deleteChapterConfirmation(item)}
                editChapter={this.props.editChapter}
                reorderChapterParts={this.props.reorderChapterParts}
                updateChapterStatus={this.props.updateChapterStatus}
                updateChapterPartStatus={this.props.updateChapterPartStatus}
                user={this.props.user}
                history={this.props.history}
                pressDelay={100}
                addTest={this.props.addTest}
            />
        );
    }
}

SortableChapterContainer.propTypes = {
    chapters: PropTypes.array.isRequired,
    number: PropTypes.number,
    showModalDelete: PropTypes.func.isRequired
};

export default SortableChapterContainer;


// WEBPACK FOOTER //
// ./src/components/AdminPanel/SortableChapterContainer.js